import { createRouter, createWebHistory } from 'vue-router';
import { routes } from '@/router/routes/routes';
import { usePermissionsStore } from '@/store/permissions.store';
import { useAuth } from '@/store/auth.store';

const BASE_URL = '/reports/';

const router = createRouter({
  history: createWebHistory(BASE_URL),
  routes,
});

router.beforeEach((to, _from, next) => {
  const { reportPermissions } = usePermissionsStore();
  const { token } = useAuth();

  if (!token || !reportPermissions) {
    throw new Error('Sorry, you are not authorized to access this page');
  }

  const selectedWhitelabelSlug = sessionStorage.getItem('selectedWhitelabelSlug');
  if (!to.query.brand && selectedWhitelabelSlug) {
    return next({ ...to, query: { brand: selectedWhitelabelSlug } });
  }

  next();
});

export default router;
